import { Component, Input, AfterViewInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "planning-region-legend-modal",
  standalone: true,
  templateUrl: "./planning-region-legend-modal.component.html",
  styleUrls: ["./planning-region-legend-modal.component.scss"],
  imports: [
    TranslateModule
  ]
})
export class PlanningRegionLegendModalComponent implements AfterViewInit {
  @Input() title: string = '';

  constructor(public activeModal: NgbActiveModal) {}

  closeModal(): void {
    this.activeModal.close();
  }

  ngAfterViewInit(): void {
    const closeButton = document.querySelector('.close') as HTMLElement;
    if (closeButton) {
      closeButton.focus();
    }
  }
}
